import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast, { Toaster } from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Header } from "antd/lib/layout/layout";
import PreferencesNav from "./PreferencesNav";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddIcon from "@mui/icons-material/Add";
import { searchForMatch } from "../utils/textUtils";
import { addQualityParaMeter, getQualityParameterList } from "../../services/Master/QualityParameterServices";

const QualityParameter = () => {
    const [file1, setFile1] = useState({
        fileBase64: "",
        fileName: "",
    });
    const [recId, setRecId] = useState("");
    const [hsn, setHsn] = useState("");
    const [note, setNote] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [filteredData2, setFilteredData2] = useState([]);
    const [show2, setShow2] = useState(false);
    const [show1, setShow1] = useState(false);

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setHsn("");
        setShow(false);
    };
    const handleShow = () => {
        setShow(true);
    };

    const columns = [
        {
            name: "Title",
            selector: (row) => row.title,
        }
    ];

    const handleSave = () => {
        if (hsn === "") {
            toast("Please fill hsnSac");
            return;
        }

        const data = {
            title: hsn,
        };
        addQualityParaMeter(data).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
                getHSNrecords();
                handleClose();
            } else {
                toast(res.message);
                return;
            }
        });
    };

    useEffect(() => {
        getHSNrecords();
    }, []);

    const getHSNrecords = () => {
        getQualityParameterList().then((res) => {
            if (res.errorCode === 0) {
                var temp = res.responsePacket.data;
                temp.reverse();
                setFilteredData(temp);
                setFilteredData2(temp);
            } else {
                toast(res.data.message);
                return;
            }
        });
    };

    const handleSearch = (key) => {
        const result = filteredData2.filter((a) => {
            return (
                searchForMatch(a.hsnSac?.toString(), key) ||
                searchForMatch(a.description, key)
            );
        });
        setFilteredData(result);
    };

    const handleClicked = (row) => {
        setRecId(row.recordId);
        setHsn(row.hsnSac);
        setNote(row.description);
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} size="sm">
                <Modal.Body>
                    <Header>Quality Info</Header>
                    <hr />
                    <table style={{ width: "100%" }}>
                        <tr>
                            <td>Title</td>
                            <td>
                                {" "}
                                <input
                                    style={{ width: "100%" }}
                                    autoComplete="off"
                                    className="ember-text-field ember-view form-control"
                                    onChange={(e) => {
                                        setHsn(e.target.value);
                                    }}
                                    value={hsn}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <div className="column list-column d-print-none column-small">
                <PreferencesNav />
            </div> */}

            <div className="column content-column">
                <div className="header clearfix" style={{ borderBottom: "none" }}>
                    <span className="float-left" style={{ fontSize: "35px" }}>
                        Quality Parameter
                    </span>
                </div>
                <div style={{ height: 500, width: "100%" }}>
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        fixedHeader
                        pagination
                        subHeader
                        highlightOnHover={true}
                        onRowClicked={(data) => handleClicked(data)}
                        subHeaderComponent={
                            <div className="d-flex align-items-center">
                                <div className="input-group mr-2 paginationSearchInput">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <SearchRoundedIcon />
                                        </span>
                                    </div>
                                    <input
                                        autoComplete="off"
                                        className="form-control"
                                        type="text"
                                        placeholder={"Search here"}
                                        onChange={(e) => handleSearch(e.target.value)}
                                    />
                                </div>
                                <button
                                    id="ember5839"
                                    className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                                    type="button"
                                    onClick={handleShow}
                                >
                                    <AddIcon />
                                    New
                                </button>
                            </div>
                        }
                    />
                </div>
            </div>
            <Toaster />
        </>
    );
};

export default QualityParameter;
